export default __webpack_public_path__ + "static/media/icon-sheet-2.024eead1.png";